import React, { useContext } from 'react';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// manor
import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    helpText: {
        marginTop: theme.spacing[4],
        fontSize: theme.fontSize.xs,
        color: theme.colors.grey700,
        lineHeight: theme.lineHeight.relaxed
    },
    secondLine: {
        fontSize: theme.fontSize.xs,
        color: theme.colors.grey700,
        display: 'inline-block'
    }
}));

const ProceedHelpText = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <Typography align="center" className={classes.helpText} data-testid="proceed-help-text">
            You will be taken to the provider's site to&nbsp;
            <Typography component="span" className={classes.secondLine}>{'complete your purchase'}</Typography>
        </Typography>
    );
};

export { ProceedHelpText };
